import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideSandbox() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const isValidEmail = (val: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setSubmitted(true);
  };
  return <Slide data-id="element-229">
      <SlideHeader data-id="element-230">Try It Live</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-4xl mx-auto w-full" data-id="element-231">
        <AnimatePresence mode="wait" data-id="element-232">
          {!submitted ? <motion.div key="form" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.4
        }} data-id="element-233">
              <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-6" data-id="element-234">
                See the live sandbox.
              </motion.h2>
              <motion.p variants={itemVariants} className="text-xl md:text-2xl text-gray-400 font-light mb-16 max-w-2xl" data-id="element-235">
                Enter your email — we'll spin up a personal Waydev environment
                loaded with sample data in seconds.
              </motion.p>

              <motion.form variants={itemVariants} onSubmit={handleSubmit} className="max-w-2xl" data-id="element-236">
                <div className="flex flex-col sm:flex-row items-stretch gap-4 border-b border-white pb-4" data-id="element-237">
                  <input type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (error) setError('');
              }} placeholder="you@company.com" autoFocus className="flex-1 bg-transparent text-2xl md:text-3xl font-light text-white placeholder:text-gray-600 focus:outline-none py-3" aria-label="Email address" data-id="element-238" />
                  <button type="submit" className="group flex items-center gap-3 px-6 py-3 bg-white text-black font-medium text-base uppercase tracking-widest hover:bg-gray-200 transition-colors" data-id="element-239">
                    Create Sandbox
                    <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" data-id="element-240" />
                  </button>
                </div>
                {error && <p className="text-sm text-gray-400 mt-4" data-id="element-241">{error}</p>}
                <p className="text-xs text-gray-500 mt-6 uppercase tracking-widest" data-id="element-242">
                  No credit card · No setup · Sample Fortune 500 data
                </p>
              </motion.form>
            </motion.div> : <motion.div key="success" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-243">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="w-16 h-16 border border-white rounded-full flex items-center justify-center mb-12" data-id="element-244">
                <Check size={28} strokeWidth={1.5} data-id="element-245" />
              </motion.div>

              <h2 className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-8" data-id="element-246">
                We just created the sandbox for you.
              </h2>

              <p className="text-xl text-gray-400 mb-12" data-id="element-247">
                A confirmation has been sent to{' '}
                <span className="text-white" data-id="element-248">{email}</span>. You can log in
                right now using the link below.
              </p>

              <a href="https://ai.waydev.co/demo-login" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-4 border border-white px-8 py-5 hover:bg-white hover:text-black transition-colors" data-id="element-249">
                <span className="text-lg font-medium uppercase tracking-widest" data-id="element-250">
                  Log in to your sandbox
                </span>
                <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" data-id="element-251" />
              </a>

              <div className="mt-8 font-mono text-sm text-gray-500 break-all" data-id="element-252">
                ai.waydev.co/demo-login
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Slide>;
}